<div class="login-dialog">
  <div class="login-dialog__header" matDialogTitle>
    <div>
      <h2>로그인</h2>
    </div>

    <button
      aria-label="로그인 팝업 닫기"
      class="login-dialog__close"
      matDialogClose
      type="button">
      <span aria-hidden="true" class="material-symbols-outlined">close</span>
    </button>
  </div>

  <form (ngSubmit)="submit()" [formGroup]="form">
    <div class="login-dialog__content" matDialogContent>
      <div *ngIf="showServiceInfo" class="login-dialog__notice">
        <span aria-hidden="true" class="material-symbols-outlined">lock</span>
        <p>로그인 후 요청하신 서비스를 이용할 수 있어요.</p>
      </div>

      <div class="login-dialog__fields">
        <mat-form-field appearance="outline">
          <mat-label>아이디(이메일)</mat-label>
          <input autocomplete="username" formControlName="username" matInput name="username" type="email">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>비밀번호</mat-label>
          <input
            [type]="showPassword ? 'text' : 'password'"
            autocomplete="current-password"
            formControlName="password"
            matInput
            name="password">
          <button
            (click)="toggleShowPassword($event)"
            [attr.aria-label]="showPassword ? '비밀번호 숨기기' : '비밀번호 표시하기'"
            class="login-dialog__password-toggle"
            matSuffix
            type="button">
            <span aria-hidden="true" class="material-symbols-outlined">
              {{ showPassword ? 'visibility' : 'visibility_off' }}
            </span>
          </button>
        </mat-form-field>
      </div>

      <button [disabled]="form.invalid || loginSubmitting" class="login-dialog__submit" mat-flat-button type="submit">
        <span *ngIf="loginSubmitting" aria-hidden="true" class="login-dialog__submit-spinner"></span>
        {{ loginSubmitting ? '로그인 중' : '로그인' }}
      </button>

      <div aria-hidden="true" class="login-dialog__divider"><span>SNS 계정으로 로그인</span></div>

      <div aria-label="SNS 로그인" class="login-dialog__sns-grid">
        <button
          (click)="loginSns('kakao')"
          class="login-dialog__sns-button"
          matTooltip="최근 로그인"
          matTooltipClass="kakao"
          matTooltipDisabled
          matTooltipPosition="above"
          type="button">
          <span class="login-dialog__sns-logo"><img alt="" src="assets/img/platform/sns-kakao.svg"></span>
          <span>카카오</span>
        </button>

        <button
          (click)="loginSns('naver')"
          class="login-dialog__sns-button"
          matTooltip="최근 로그인"
          matTooltipClass="naver"
          matTooltipDisabled
          matTooltipPosition="above"
          type="button">
          <span class="login-dialog__sns-logo"><img alt="" src="assets/img/platform/sns-naver.svg"></span>
          <span>네이버</span>
        </button>

        <button
          (click)="loginSns('google')"
          *ngIf="showGoogleLogin"
          class="login-dialog__sns-button"
          matTooltip="최근 로그인"
          matTooltipClass="google"
          matTooltipDisabled
          matTooltipPosition="above"
          type="button">
          <span class="login-dialog__sns-logo"><img alt="" src="assets/img/platform/sns-google.svg"></span>
          <span>구글</span>
        </button>

        <button
          (click)="loginSns('apple')"
          class="login-dialog__sns-button"
          matTooltip="최근 로그인"
          matTooltipClass="apple"
          matTooltipDisabled
          matTooltipPosition="above"
          type="button">
          <span class="login-dialog__sns-logo"><img alt="" src="assets/img/platform/sns-apple.svg"></span>
          <span>애플</span>
        </button>
      </div>

      <a class="login-dialog__find" matDialogClose routerLink="/account">
        아이디 · 비밀번호 찾기
      </a>

      <div class="login-dialog__join">
        <div>
          <strong>아직 체크팀 회원이 아니신가요?</strong>
          <p>가입하고 무료 이용 쿠폰을 받아보세요.</p>
        </div>
        <a matDialogClose routerLink="/join">회원가입</a>
      </div>
    </div>
  </form>
</div>
